import { CommonModule } from '@angular/common';
import { Component, input, output } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { DocumentItemPartial, DocumentItemTypeEnum } from '@domain';
import { IaItemComponent } from './ia-item/ia-item.component';

@Component({
    selector: 'ia-options',
    templateUrl: 'ia-options.component.html',
    styleUrl: 'ia-options.component.scss',
    imports: [CommonModule, IaItemComponent, TranslatePipe],
})
export class IaOptionsComponent {
    public field = input.required<DocumentItemPartial>();
    public isHidden = input(true);
    /** Há texto pré-IA guardado para este campo (mostra "Voltar ao texto original"). */
    public hasOriginalBackup = input(false);
    public close = output<void>();
    public fixText = output<void>();
    public useAsPrompt = output<void>();
    public generateAutomaticDescription = output<void>();
    public restoreOriginalText = output<void>();
    public DocumentItemTypeEnum = DocumentItemTypeEnum;
}
